'use client';

import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function MemberZoneNotLogged() {
  const { t } = useTranslations();

  return (
    <section
      className={cn(
        'custom-section',
        'gap-12 pb-12 pt-12 sm:pt-20 lg:gap-16 lg:pb-24 lg:pt-32 xl:gap-12',
      )}
    >
      <h2 className="w-full max-w-[580px] text-center text-2xl font-medium text-primary sm:text-3xl lg:text-4xl">
        {t('text3233')}&nbsp;
        <Link
          prefetch={false}
          href={ROUTES.SIGN_IN()}
          className="font-bold text-secondary underline"
        >
          {t('text3234')}
        </Link>
      </h2>
      <Button asChild variant={'secondary'}>
        <Link prefetch={false} href={ROUTES.SIGN_IN()}>
          {t('text189')}
        </Link>
      </Button>
    </section>
  );
}
